import useI18n from 'i18n';
import styled from 'styled-components';

import FlatRows from '../../../Components/FlatRows';
import { ReactComponent as ArrowIcon } from 'Assets/Icons/navigate-right.svg';

const Wrapper = styled.div`
  background: #f8f8fb;
  margin-top: 6px;
`;

const Title = styled.div<{ fullWidth?: boolean; isLink?: boolean }>`
  flex: ${({ fullWidth }) => (fullWidth ? 1 : 'none')};
  color: rgb(117, 117, 120);
  font-weight: 600;
  padding: 18px 24px 0;
  cursor: ${({ isLink }) => (isLink ? 'pointer' : 'default')};

  svg {
    width: 12px;
    height: 12px;
    margin-left: 5px;
    fill: rgb(117, 117, 120);
  }

  @media (min-width: 768px) {
    &:hover {
      text-decoration: ${({ isLink }) => (isLink ? 'underline' : 'none')};
    }
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

type Props = {
  /**
   * children
   */
  children: React.ReactNode;
  /**
   * title
   */
  title: string;
  /**
   * categoryId
   */
  categoryId?: string;
  /**
   * toMenu
   */
  toMenu?: (categoryId: string) => void;
};

/**
 * Home page row component
 */
const Row = ({ children, title, categoryId, toMenu }: Props) => {
  const { i18n } = useI18n();

  return (
    <Wrapper>
      <TitleContainer>
        <Title fullWidth>{title}</Title>
        {categoryId && toMenu && (
          <Title onClick={() => toMenu(categoryId)} isLink={Boolean(toMenu)}>
            {i18n('Home.Categories.More')}
            <ArrowIcon />
          </Title>
        )}
      </TitleContainer>
      <FlatRows>{children}</FlatRows>
    </Wrapper>
  );
};

export default Row;
